import React, { Suspense } from 'react';
import { Route, Redirect } from 'react-router-dom';
import AuthService from 'services/Auth';
import routeCodes from 'common/constants/route-codes';
import LazyLoader from 'components/atoms/Loaders/LazyLoader';
import { useUser } from '../../redux/user/use-user';
import { useBootstrapCalls } from '../../hooks/use-bootsrap-calls';

const ProtectedLazyRoute = ({ component: Component, ...rest }) => {
  const token = AuthService.getToken();
  const { isSuperAdmin, getInProcess, userData } = useUser();
  const shouldBootstrap = Boolean(
    token && !getInProcess && userData?.role && !isSuperAdmin,
  );

  useBootstrapCalls({ enabled: shouldBootstrap });

  return token ? (
    <Route
      {...rest}
      render={(matchProps) => (
        <Suspense fallback={<LazyLoader />}>
          <Component {...matchProps} />
        </Suspense>
      )}
    />
  ) : (
    <Redirect
      to={{
        pathname: routeCodes.signIn,
        search: window.location.search,
      }}
    />
  );
};

export default ProtectedLazyRoute;
